import React from "react";
import "./DetailsPanel.scss"; // optional

const DetailsPanel = ({
  data,
  type,
  onRemove,
  onCopy,
  onToggleFavourite,
  isFavourite,
}) => {
  if (!data) {
    return <p className="function-details">Select a {type} to view details</p>;
  }

  return (
    <div className="function-details">
      <h2>{type === "function" ? data.name?.toLowerCase() : data.client}</h2>

      {type === "quirk" ? (
        <>
          <div className="function__container">
            <h4>Quirk</h4>
            <p dangerouslySetInnerHTML={{ __html: data.quirk }} />
          </div>
          <div className="function__description-cont">
            <h4>Description</h4>
            <p dangerouslySetInnerHTML={{ __html: data.desc }} />
          </div>
          <div className="buttons">
            <button className="remove" onClick={() => onRemove(data.id)}>
              Remove
            </button>
          </div>
        </>
      ) : (
        <>
          <p>{data.desc}</p>
          <div className="buttons">
            <button onClick={() => onCopy(data)}>Copy</button>
            <button className="remove" onClick={() => onRemove(data.id)}>Remove</button>
            <button onClick={() => onToggleFavourite(data)}>
              {isFavourite ? "Unfavourite" : "Favourite"}
            </button>
          </div>
          <pre>
            <code>{data.func}</code>
          </pre>
        </>
      )}
    </div>
  );
};

export default DetailsPanel;
